// extracted by mini-css-extract-plugin
export default {"container":"Cell_container__DDK5Q","content":"Cell_content__puAvQ"};